<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Art.-Nr Dose</th>
          <th scope="col" class="multi-line-header">Batch Nummer</th>
          <th scope="col" class="multi-line-header">Herstellerdatum</th>
          <th scope="col" class="multi-line-header">Diodentyp i.O.?</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateInProduction.replace("T", " ") }}</td>

          <td>{{ entry.username }}</td>

          <td>{{ entry.jBoxtype }}</td>

          <td>{{ entry.jBoxbatch }}</td>

          <td>
            {{ entry.manufacturingdate.split("T")[0] }}
          </td>

          <td v-if="entry.isDiodesApproved">Ja</td>
          <td v-else>Nein</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, defineEmits } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);
const emit = defineEmits(["updateLatestJBoxBatch"]);

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;

    if (data.length > 0) {
      const latestEntry = data[0];
      emit("updateLatestJBoxBatch", latestEntry.jBoxbatch.split("-")[0] + "-");
    }
  } catch (error) {
    if (error.response) {
      console.log(`HTTP error! Status: ${error.response.status}`);
    } else {
      console.log("Netzwerkproblem:", error.message);
    }
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.expired {
  color: darkorange !important;
}
</style>
